import React from "react";
import styles from "./stylesComponent/CardResennas.module.css";
import { FaStar, FaRegStar, FaStarHalfAlt} from "react-icons/fa";
import { useState, useEffect } from "react";



const CardResennas = ({resena}) => {

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';

    const [cliente, setCliente] = useState(null);

    //Obtener datos del cliente que hizo la reseña
    const getCliente = async(id) => {
        try{
            const response = await fetch(`${baseUrl}/api/users/${id}`, {
                method: "GET",
                headers: {
                'Content-Type': 'application/json', 
                },
            });

            if (!response.ok) {
                throw new Error("Cliente no encontrado o error en la respuesta");
            }

            const client = await response.json();
            setCliente(client);
        } catch (error){
            console.error("Error al obtener el cliente" + error.message);
        }    
    };

     useEffect(() => {
            if(resena.Id_Usuario) getCliente(resena.Id_Usuario);
    }, [resena.Id_Usuario]);

    return(
        <div className={styles.card}>
            <div className={styles.cabecera}>
                <div className={styles.image}>
                    {cliente ? (
                        <img src={`data:image/png;base64,${cliente.ImagenPerfil}`} alt={`${cliente.Nombre} ${cliente.Apellidos}`} />
                    ) : (
                         <div style={{
                                width: "50px",
                                height: "50px",
                                backgroundColor: "#ddd",
                                borderRadius: "50%",
                                display: "inline-block",
                            }}
                        />
          
                    )}
                </div>
                <div className={styles.nombreFecha}>
                    <div className={styles.nombreCliente}>

                        {cliente ? (
                            <p>{cliente.Nombre} {cliente.Apellidos}</p>
                        ) : (
                            <p style={{ fontStyle: "italic", color: "#888" }}>
                                Cuenta de cliente eliminada
                            </p>
                        )}
                    </div>
                    <div className={styles.fechaResenna}>
                        <p className={styles.fechaResenna}>
                            {new Date(resena.Fecha)
                                        .toLocaleDateString("es-ES", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric"
                                    })
                                    .replace(/\//g, "-")}
                        </p>
                    </div>
                </div>
            </div>
            <div className={styles.descripcionTitulo}>
                <div className={styles.tituloResenna}>
                    <strong><h4>{resena.Titulo}</h4></strong>
                </div>
                <div className={styles.descripcionResenna}>
                    <p className={styles.descripcion}>{resena.Descripcion}</p>
                </div>
                <div className={styles.valoracion}>
                    {Array.from({length: 5}, (_, index) =>{
                        const rating = resena.Valoracion;
                        const entero = Math.floor(rating);
                        const decimal = rating - entero

                        if(index < entero) {
                            return <FaStar key={index} />;
                        }
                        else if (index === entero && decimal >= 0.5){
                            return <FaStarHalfAlt key={index} />;
                        }
                        else{
                            return <FaRegStar key={index} />;
                        }
                    })}
                </div>
            </div>
        </div>
    );
};

export default CardResennas;